import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import type { FunctionalComponent } from "vue";
import type { MaybeRef } from "@vueuse/core";
import { useTranslations } from "@/composables/useTranslations";
import { useTeamsAndMembers } from "@/composables/useTeamsAndMembers";
import route from "ziggy-js";

import {
    UserGroupIcon,
    Cog8ToothIcon,
    UserIcon,
    UsersIcon,
    SpeakerWaveIcon,
    IdentificationIcon,
    GlobeAltIcon,
    DocumentChartBarIcon,
    ArchiveBoxXMarkIcon,
    CreditCardIcon,
    WrenchScrewdriverIcon,
    ChartBarIcon,
    BellIcon,
    ExclamationTriangleIcon,
} from "@heroicons/vue/24/outline";

interface ILink {
    name: string;
    href: string;
    icon: FunctionalComponent;
    count?: MaybeRef<number>;
    id: string;
    tooltip?: string;
}

const { membersCount } = useTeamsAndMembers();

export default () => {
    const page = computed(() => usePage<IRhizomPageProps>().url);
    const { t } = useTranslations();
    const globalProps = computed(() => usePage<IRhizomPageProps>().props);

    const linksApp = computed((): ILink[] => {
        const links: ILink[] = [
            {
                name: t("vue.dashboard"),
                href: route("home"),
                icon: DocumentChartBarIcon,
                id: "/dashboard",
            },
            {
                name: t("vue.domains"),
                href: route("domains.index"),
                icon: GlobeAltIcon,
                id: "/domains",
            },
            {
                name: t("vue.blacklists"),
                href: route("blacklists.index"),
                icon: ArchiveBoxXMarkIcon,
                id: "/blacklists",
            },
            {
                name: t("vue.reports"),
                href: route("reports.index"),
                icon: ChartBarIcon,
                id: "/reports",
            },
            {
                name: t("vue.alerts"),
                href: route("alerts.overview"),
                icon: BellIcon,
                id: "/alerts",
            },
        ];

        // links.splice(3, 0, {
        //     name: "Members",
        //     href: route("members.index"),
        //     icon: UserGroupIcon,
        //     count: membersCount.value,
        //     id: "/members",
        // });
        // if (globalProps.value.isAdmin) {
        //     links.splice(4, 0, {
        //         name: "Team Settings",
        //         href: route("settings.team-settings.index"),
        //         icon: Cog8ToothIcon,
        //         count: undefined,
        //         id: "/settings",
        //     });
        // }
        return links;
    });

    const linksKiosk = computed((): ILink[] => {
        return [
            {
                name: t("vue.users_profiles"),
                href: route("kiosk.users.index"),
                icon: UserIcon,
                id: "/kiosk/users",
            },
            {
                name: t("vue.teams_accounts"),
                href: route("kiosk.teams.index"),
                icon: UsersIcon,
                id: "/kiosk/teams",
            },
            {
                name: t("vue.admins"),
                href: route("kiosk.admins.index"),
                icon: IdentificationIcon,
                id: "/kiosk/admins",
            },
            {
                name: t("vue.announcements"),
                href: route("kiosk.announcements.index"),
                icon: SpeakerWaveIcon,
                id: "/kiosk/announcements",
            },
            {
                name: t("vue.alert_logs"),
                href: route("kiosk.alert-logs.index"),
                icon: ExclamationTriangleIcon,
                id: "/kiosk/alert-logs",
            },
            {
                name: t("vue.tools"),
                href: route("kiosk.tools.index"),
                icon: WrenchScrewdriverIcon,
                id: "/kiosk/tools",
            },
            // {
            //     name: 'Lambdas',
            //     href: route('kiosk.lambdas.index'),
            //     icon: MusicalNoteIcon,
            //     id: '/kiosk/lambdas',
            // },
        ];
    });
    const links = computed(() => {
        return page.value.startsWith("/kiosk")
            ? linksKiosk.value
            : linksApp.value;
    });

    return {
        links,
    };
};
